"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "RadioGroup";
exports.classes = {
    item: `${PREFIX}-item`
};
exports.Container = (0, styles_1.styled)("div")({
    padding: 0,
    display: "flex",
    flexFlow: "row wrap",
    margin: "-12px",
    [`.${exports.classes.item}`]: {
        margin: "12px"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JhZGlvLWdyb3VwL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpREFBOEM7QUFFOUMsTUFBTSxNQUFNLEdBQUcsWUFBWSxDQUFDO0FBRWYsUUFBQSxPQUFPLEdBQUc7SUFDckIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0NBQ3ZCLENBQUM7QUFFVyxRQUFBLFNBQVMsR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUNyQyxPQUFPLEVBQUUsQ0FBQztJQUNWLE9BQU8sRUFBRSxNQUFNO0lBQ2YsUUFBUSxFQUFFLFVBQVU7SUFDcEIsTUFBTSxFQUFFLE9BQU87SUFDZixDQUFDLElBQUksZUFBTyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDcEIsTUFBTSxFQUFFLE1BQU07S0FDZjtDQUNGLENBQUMsQ0FBQyJ9